import { join } from 'light-component';
import { Block, Box } from '@common';
import * as Base from '@base';
import styles from '../style.module.less';
import { service } from '../service';
import { Highlighter } from '../../component';
import { CheckBoxComponent } from './checkbox';
import type { ReactElement } from 'react';
import type { CheckBoxProps } from './types';

export function CheckBoxInputMode(props: CheckBoxProps): ReactElement {
  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Block if={props.number != null}>{props.number}、</Block>
        <Block if={props.typeName != null}>
          <Base.Tag color='#ff943f'>{props.typeName}</Base.Tag>
        </Block>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
          require={props.validator === 'required'}
        />
      </Box>
      <Box className={join(styles.action, styles.input)}>
        <CheckBoxComponent {...props} />
      </Box>
    </Box>
  );
}
